import React from "react";
import PublicLayout from "../layout/PublicLayout";

export default function SimplePage({ eyebrow, title, text, loading }) {
  if (loading) {
    return (
      <PublicLayout>
        <div className="mx-auto max-w-3xl px-4 py-20 text-center text-muted-foreground">Loading…</div>
      </PublicLayout>
    );
  }
  const paragraphs = (text || "").split(/\n\n+/).map((p) => p.trim()).filter(Boolean);
  return (
    <PublicLayout>
      <section className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-[10px] uppercase tracking-[0.2em] text-accent font-bold mb-3">{eyebrow}</div>
        <h1 className="font-display text-3xl md:text-4xl font-bold tracking-tight mb-8">{title}</h1>
        <div className="space-y-4">
          {paragraphs.map((p, i) => (
            <p key={i} className="text-sm text-muted-foreground leading-relaxed">{p}</p>
          ))}
        </div>
      </section>
    </PublicLayout>
  );
}
